import React from 'react';

const PiPLoader: React.FC = () => {
  return (
    <div
      id="pip-loader"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        padding: '2rem',
        fontFamily: 'sans-serif',
        textAlign: 'center',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          animation: 'spin 1s linear infinite',
          width: '80px',
          height: '80px',
          border: '4px solid rgba(0, 0, 0, 0.15)',
          borderTopColor: 'var(--button-bg)',
          borderRadius: '50%',
        }}
      />
      <p
        style={{
          background: 'transparent',
          color: 'var(--font-color)',
          border: 'none',
          marginTop: '1.5rem',
          fontSize: '20px',
          margin: '1.5rem 0 0 0',
        }}
      >
        <strong style={{ fontWeight: '600' }}>Loading...</strong>
        <br />
        We're just making the magic happen!
      </p>

      {/* Inline @keyframes to avoid stylesheet dependency */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default PiPLoader;
